const menu = {
  Home: [{
    title: '最新消息',
    path: '#news',
    submenu: [],
  }, {
    title: '海外學員分享',
    path: '#share',
    submenu: [],
  }, {
    title: '歸國學員特寫',
    path: '#participants',
    submenu: [],
  }],
  Apply: [{
    title: '線上報名',
    path: '/apply',
    submenu: [],
  }],
  NewApply: [{
    title: '線上報名',
    path: '/new-apply',
    submenu: [],
  }],
  InstitutePage: [{
    title: '海外培訓機構',
    path: '/institutes',
    submenu: [],
  }],
  ApplyLogin: [{
    title: '線上報名',
    path: '/apply-login',
    submenu: [],
  }],
  About: [{
    title: '計畫緣起',
    path: '#desc',
    submenu: [],
  }, {
    title: '各組特色',
    path: '#gruop-intro',
    submenu: [],
  }, {
    title: '計畫目標',
    path: '#features',
    submenu: [],
  }, {
    title: '辦理方式<br/>及時程',
    path: '#schedule',
    submenu: [],
  }, {
    title: '海外培訓機構',
    path: '#institutes',
    submenu: [],
  }],
  AboutEn: [{
    title: 'Introduction',
    path: '#desc',
    submenu: [],
  }, {
    title: 'Selection Process',
    path: '#schedule',
    submenu: [],
  }, {
    title: 'Record of Achievement',
    path: '#achievement',
    submenu: [],
  }, {
    title: 'Overseas Partner Institutes',
    path: '#institutes',
    submenu: [],
  }],
  CampList: [{
    title: '各階段名單',
    path: '/camp-lists/phase1',
    submenu: [{
      title: '國內研習營',
      path: '/camp-lists/phase1',
      submenu: [],
    }, {
      title: '國內研習排序',
      path: '/camp-lists/phase2',
      submenu: [],
    }, {
      title: '國內複審名單',
      path: '/camp-lists/phase3',
      submenu: [],
    }, {
      title: '海外培訓名單',
      path: '/camp-lists/phase4',
      submenu: [],
    },
    ],
  }, {
    title: '研習營課程<br/>及師資',
    path: '/camp-courses',
    submenu: [],
  }],
  CampCourses: [{
    title: '各階段名單',
    path: '/camp-lists/phase1',
    submenu: [],
  }, {
    title: '研習營課程<br/>及師資',
    path: '/camp-courses',
    submenu: [],
  }],
  Download: [{
    title: '資料下載',
    path: '/download',
    submenu: [],
  }],
  Records: [{
    title: '歷屆計畫',
    path: '/records',
    submenu: [],
  }, {
    title: '課程分享',
    path: '/online-courses',
    submenu: [],
  }],
  OnlineCourses: [{
    title: '歷屆計畫',
    path: '/records',
    submenu: [],
  }, {
    title: '課程分享',
    path: '/online-courses',
    submenu: [],
  }],
};

const pageTitles = {
  Home: '最新消息',
  Apply: '線上報名',
  ApplyLogin: '線上報名',
  About: '計畫簡介',
  InstitutePage: '海外培訓機構',
  CampList: '各階段名單',
  CampCourses: '研習營課程及師資',
  Download: '下載專區',
  Records: '歷屆計畫',
  OnlineCourses: '課程分享',
};
menu.CampList2 = menu.CampList;
menu.CampList3 = menu.CampList;
menu.CampList4 = menu.CampList;

export { menu, pageTitles };
